import remToPx from '../../utils/remToPx';
import { Panel } from 'react-resizable-panels';

export interface ITabsContainerProps {
	tabsCollapsed: boolean;
	children?: React.ReactNode;
	size?: number;
}

const TabsContainer: React.FunctionComponent<ITabsContainerProps> = ({ tabsCollapsed, children, size }) => {
	const tabsDefaultSizeRems = 22;
	const tabsMaxSizePercentage = 50;

	return (
		<Panel
			style={{ display: tabsCollapsed ? 'none' : 'flex' }}
			defaultSizePixels={Number.isNaN(size) ? remToPx(tabsDefaultSizeRems) : size}
			minSizePixels={remToPx(tabsDefaultSizeRems)}
			maxSizePercentage={tabsMaxSizePercentage}
		>
			{children}
		</Panel>
	);
};

export default TabsContainer;
